module.exports = __webpack_public_path__ + "assets/img/007353d1bf490361da0dd6dc878d9894.png";